import React from 'react';
import PropTypes from 'prop-types';
import ApprovedPurchaseOrderBody from '../../../../shared/purchase-order/approved-po/ApprovedPurchaseOrderBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { ACCOUNTS, SUPER_ADMIN } from '../../../../../../utils/departments/helpers';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import AccountsNavBar from '../../../../../layouts/accounts/AccountsNavBar';

const ApprovedPurchaseOrder = ({ history }) => {
  useCheckTwoDepartments(`${ACCOUNTS}`, `${SUPER_ADMIN}`, history);
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <span className="d-none d-md-block">
          <AccountsNavBar currentPage="Approved Purchase Order" position={firstName} />
        </span>
        <span className="d-md-none d-block">
          <AccountsNavBar currentPage="Approved PO" position={firstName} />
        </span>
        <ApprovedPurchaseOrderBody />
      </main>
    </div>
  );
};

ApprovedPurchaseOrder.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default ApprovedPurchaseOrder;
